import axios from "axios"

// content type
axios.defaults.headers.post["Content-Type"] = "application/json"
axios.defaults.baseURL = process.env.REACT_APP_API_URL

// intercepting to capture errors
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

class APICore {
  /**
   * post given data to url with file
   */
  uploadFile = (url, data, onUploadProgress) => {
    const formData = new FormData()
    for (const k in data) {
      formData.append(k, data[k])
    }
    const user = localStorage.getItem("persist:user")
    let token = ""
    if (user) {
      const formattedUser = JSON.parse(user)
      if (formattedUser && formattedUser.jwt) {
        let jwt = formattedUser.jwt
        if (
          typeof jwt === "string" &&
          jwt.startsWith('"') &&
          jwt.endsWith('"')
        ) {
          token = jwt.slice(1, -1)
        }
      }
    }

    const config = {
      headers: {
        ...axios.defaults.headers,
        Authorization: `Bearer ${token}`,
        "content-type": "multipart/form-data",
      },
      onUploadProgress,
    }
    return axios.post(url, formData, config)
  }
  /**
   * post given data to url with files
   */
  uploadMultipleFile = (url, formData) => {
    const config = {
      headers: {
        ...axios.defaults.headers,
        "content-type": "multipart/form-data",
      },
    }
    return axios.post(url, formData, config)
  }
}

export { APICore }
